import { createSelector } from 'reselect';

import { getNetAssetValues } from 'Selectors/common';

export const getNetAssetValuesAsCurCode = createSelector(
    [getNetAssetValues],
    (netAssetValues) => netAssetValues
);

export const getNetAssetValuesByAssetId = createSelector(
    [getNetAssetValues],
    (netAssetValues) => netAssetValues
);